import { cva, type VariantProps } from 'class-variance-authority';

/** Track shared by `ProgressBar` and `StackedProgressBar`. */
export const progressTrackVariants = cva(
  'relative w-full overflow-hidden rounded-sm bg-border-base',
  {
    variants: {
      size: {
        sm: 'h-1',
        md: 'h-1.5',
        lg: 'h-2'
      },
      muted: {
        true: 'bg-border-base/40',
        false: ''
      }
    },
    defaultVariants: {
      size: 'md',
      muted: false
    }
  }
);

/** Background class of each fill colour, also for legend swatches that name a segment. */
export const PROGRESS_FILL_CLASS = {
  neutral: 'bg-border-base',
  primary: 'bg-primary-base',
  success: 'bg-success-border',
  info: 'bg-info-border',
  warn: 'bg-warn-border',
  error: 'bg-error-border'
} as const;

/** Background class of the empty track, for a swatch that names the unused part. */
export const PROGRESS_TRACK_CLASS = 'bg-border-base';

/** Fill colour; a lone fill is rounded, stacked segments sit flush. */
export const progressFillVariants = cva('h-full transition-all', {
  variants: {
    variant: PROGRESS_FILL_CLASS,
    segment: {
      true: 'shrink-0',
      false: 'rounded-sm'
    }
  },
  defaultVariants: {
    variant: 'primary',
    segment: false
  }
});

export type ProgressTrackVariantProps = VariantProps<typeof progressTrackVariants>;

/** Colour of a progress fill. */
export type ProgressBarVariant = NonNullable<VariantProps<typeof progressFillVariants>['variant']>;
